import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// iOS UITabBar mirror: fixed bottom bar, white, hairline top border,
// icon + 10px label per tab, red tint when active, badge support.
// tabs: [{ to, label, Icon, badge, protected }]
export default function TabBar({ tabs }) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-black/10 pb-[env(safe-area-inset-bottom)]">
      <div className="flex max-w-lg mx-auto">
        {tabs.map(({ to, label, Icon, badge = 0, protected: needsAuth }) => (
          <NavLink
            key={to}
            to={to}
            end={false}
            onClick={(e) => {
              if (needsAuth && !currentUser) {
                e.preventDefault();
                navigate('/login');
              }
            }}
            className={({ isActive }) =>
              `relative flex-1 flex flex-col items-center gap-0.5 pt-1.5 pb-1 text-[10px] font-medium ${
                isActive ? 'text-[#FF3B30]' : 'text-[#8E8E93]'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className="relative">
                  <Icon size={24} strokeWidth={isActive ? 2.2 : 1.7} />
                  {badge > 0 && (
                    <span className="absolute -top-1.5 -right-2.5 min-w-[17px] h-[17px] px-1 rounded-full bg-[#FF3B30] text-white text-[10px] font-bold flex items-center justify-center border border-white">
                      {badge > 99 ? '99+' : badge}
                    </span>
                  )}
                </span>
                <span className="leading-tight">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
